module.exports = __webpack_public_path__ + "img/1.c148d0f2.jpg";